module.exports = __webpack_public_path__ + "img/friosImage.76c48580.svg";